import React, { useState, useRef } from 'react'
import DropdownHeader from './DropdownHeader'
import DropdownContent from './DropdownContent'

const DropdownContentComponent = ({btnTxt, dropdownContent, isLong}) => {

    const [open, setOpen] = useState(false);
    const drop = useRef(null);

    //!!!!Code below means when you click somewhere else on page the dropdown will close!!!!
    // function handleClick(e){
    //     if(!e.target.closest(`.${drop.current.className}`) && open ){
    //         setOpen(false);
    //     }
    // }
    // useEffect(() => {
    //     document.addEventListener("click", handleClick);
    //     return () => {
    //         document.removeEventListener("click", handleClick)
    //     }
    //   });

  return (
    <div className='dropdown_content_component' ref={drop}>
        <DropdownHeader btnTxt={btnTxt} open={open} isLong={isLong} onClick={() => setOpen(open => !open)}/>
        <div className={`dropdown_container ${open ? 'active' : ''}`}>
            {open && <DropdownContent dropdownContent={dropdownContent} setOpen={setOpen}/>}
        </div>
    </div>
  )
}

export default DropdownContentComponent